export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Awards', href: '#awards' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Videos', href: '#videos' },
    { name: 'Personal', href: '#personal' }
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    { icon: 'ri-twitter-x-fill', href: '#', label: 'Twitter' },
    { icon: 'ri-instagram-fill', href: '#', label: 'Instagram' },
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' }
  ];

  return (
    <footer id="contact" className="relative bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <h3 className="text-2xl font-bold text-black mb-4 tracking-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
              Brayan Fernandez
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6" style={{ fontFamily: "'Inter', sans-serif", lineHeight: '1.7' }}>
              Dedicated to excellence in academics, leadership, and community service. Building a better future through education and compassion.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-700 hover:bg-[#800000] hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-black uppercase tracking-wider mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-600 hover:text-[#800000] transition-colors duration-300 cursor-pointer inline-flex items-center gap-2 group"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span className="w-1 h-1 bg-gray-400 group-hover:bg-[#800000] transition-colors duration-300"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold text-black uppercase tracking-wider mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Get In Touch
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-700">
                  <i className="ri-mail-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1 font-semibold" style={{ fontFamily: "'Inter', sans-serif" }}>Email</p>
                  <a href="mailto:brayanfernandez.07j@gmail.com" className="text-sm text-gray-700 hover:text-[#800000] transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                    brayanfernandez.07j@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-700">
                  <i className="ri-phone-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1 font-semibold" style={{ fontFamily: "'Inter', sans-serif" }}>Phone</p>
                  <a href="tel:+1234567890" className="text-sm text-gray-700 hover:text-[#800000] transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                    +1 (786)-271-0759
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500" style={{ fontFamily: "'Inter', sans-serif" }}>
              © {currentYear} Brayan Fernandez. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-gray-500 hover:text-[#800000] transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Privacy Policy
              </a>
              <a href="#" className="text-xs text-gray-500 hover:text-[#800000] transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 hover:text-[#800000] transition-colors duration-300 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
